/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface PhoneModel {

        "ddd"?: number;

        "phone"?: number;

        "type"?: string;
    }

}
